import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Politique et conditions d'utilisation générale ", -1)
const _hoisted_7 = { class: "mb-0" }
const _hoisted_8 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Expédition et livraison ", -1)
const _hoisted_12 = { class: "mb-0" }
const _hoisted_13 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_14 = { class: "col-md-12" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Politique de retour et de remboursement ", -1)
const _hoisted_17 = { class: "mb-0" }
const _hoisted_18 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_19 = { class: "col-md-12" }
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Qui sommes nous ? ", -1)
const _hoisted_22 = { class: "mb-0" }
const _hoisted_23 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_24 = { class: "col-md-12" }
const _hoisted_25 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Contact ", -1)
const _hoisted_27 = { class: "mb-0" }
const _hoisted_28 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_29 = { class: "col-md-12" }
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "infoFooterForm",
        onSubmit: _ctx.editInfoFooter,
        "validation-schema": _ctx.infoFooterSchema,
        "initial-values": _ctx.infoFooterForm
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_QuillEditor, {
                    ref: "politiqueConditionEditor",
                    theme: "snow",
                    placeholder: "Écrire la politique",
                    toolbar: "full",
                    name: "politiqueCondition"
                  }, null, 512)
                ]),
                (_ctx.show === '1')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Ce champ est obligatoire"))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "politiqueCondition",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_QuillEditor, {
                    ref: "expeLivraisonEditor",
                    theme: "snow",
                    placeholder: "Écrire les informations",
                    toolbar: "full",
                    name: "expeLivraison"
                  }, null, 512)
                ]),
                (_ctx.show === '1')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Ce champ est obligatoire"))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "expeLivraison",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_QuillEditor, {
                    ref: "politiqueRREditor",
                    theme: "snow",
                    placeholder: "Écrire la politiqueRR",
                    toolbar: "full",
                    name: "politiqueRR"
                  }, null, 512)
                ]),
                (_ctx.show === '1')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, "Ce champ est obligatoire"))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "politiqueRR",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_QuillEditor, {
                    ref: "quiSommeNousEditor",
                    theme: "snow",
                    placeholder: "Qui sommes-nous",
                    toolbar: "full",
                    name: "quiSommeNous"
                  }, null, 512)
                ]),
                (_ctx.show === '1')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_23, "Ce champ est obligatoire"))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "quiSommeNous",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_QuillEditor, {
                    ref: "contactEditor",
                    theme: "snow",
                    placeholder: "Renseigner le contact",
                    toolbar: "full",
                    name: "contact"
                  }, null, 512)
                ]),
                (_ctx.show === '1')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_28, "Ce champ est obligatoire"))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorMessage, {
                  name: "contact",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                  type: "submit",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSubmit()))
                }, " Modifier "),
                _createVNode(_component_router_link, {
                  to: "/liste-infoFooter",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_31,
                    _hoisted_32,
                    _createTextVNode("Annuler")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "initial-values"])
    ])
  ]))
}